module.exports = __webpack_public_path__ + "img/2HONEY.293c9a36.png";